import { CommonService } from '../../../base-services/common.service';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseNumberInput } from './base-number-input';
import { UserService } from '../../../base-services/user.service';
import { ChangeDetectorRef } from '@angular/core';
import { MakeProvider } from '../../abstract-custom-control';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'yt-number-input-v1',
    templateUrl: './number-input.component.html',
    providers: [ MakeProvider(NumberInputComponentV1) ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberInputComponentV1 extends BaseNumberInput {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected commonService: CommonService,
        protected decimalPipe: DecimalPipe
    ){
        super(changeDetectorRef, userService, decimalPipe);
    }

    private enteredDigits: string = '';
    private initValue: number = 0;

    ngOnInit(){
        super.ngOnInit();

        this.displayValue = '0' + this.ds + '00';
        this.value = 0;
    }

    onKeyDown(event){
        if(!this.isAllowed(event.keyCode))
            this.prevent(event);
        
        this.enteredDigits.slice(event.target.selectionStart, event.target.selectionEnd);
        if(event.target.selectionEnd - event.target.selectionStart > this.enteredDigits.length)
            this.enteredDigits = '';
        
        if(event.keyCode == 27)
            this.enteredDigits = this.oldValue.toString().replace('.','');
        
        if(this.isNumber(event.keyCode)){
            this.enteredDigits += event.key;
        }
        else if(this.isBackspace(event.keyCode)){
            this.enteredDigits = this.enteredDigits.substring(0, this.enteredDigits.length - 1);
        }

        if(this.isNumber(event.keyCode) || this.isBackspace(event.keyCode) || event.keyCode == 27){
            //let wholePart: string = this.enteredDigits.substring(0, this.enteredDigits.length - this.nofd);
            //let decimalPart: string = this.commonService.PadLeft(this.enteredDigits.substring(this.enteredDigits.length - this.nofd), '0', this.nofd);

            //this.displayValue = this.decimalPipe.transform((wholePart == '' ? '0' : wholePart) + '.' + decimalPart, this.FormatString, this.userService.GetLocaleString());
            this.displayValue = this.getDisplayValue(this.enteredDigits);

            this.value = parseFloat(this.displayValue.replace(new RegExp('\\' + this.ts, 'g'), '').replace(this.ds, '.'));

            this.prevent(event);
        }
    }

    writeValue(value){
        super.writeValue(value);
        if(value == null)
            this.value = this.initValue;
        this.oldValue = this.value;
        this.displayValue = this.getDisplayValue(this.value.toString().replace('.',''));
        this.enteredDigits = this.value.toString().replace('.','');
        this.changeDetectorRef.markForCheck();
    }

    private getDisplayValue(value: string){
        let wholePart: string = value.substring(0, value.length - this.nofd);
        let decimalPart: string = this.commonService.PadLeft(value.substring(value.length - this.nofd), '0', this.nofd);

        return this.decimalPipe.transform((wholePart == '' ? '0' : wholePart) + '.' + decimalPart, this.FormatString, this.userService.GetLocaleString());
    }
}